module.exports = __webpack_public_path__ + "img/Bloque_Button.ce604a9.svg";